import { Button, Spacing, Spinner, StatusLabel } from "@snapchat/snap-design-system";
import { FC } from "react";
import { State } from "@snap/push2web";
import { FlexSection, LoginKitPanel, useLoginKitState } from "shared-resources";
import { css } from "@emotion/react";

const buttonStyle = css`
    margin-left: ${Spacing.SM}px;
`;

export const Push2WebPanel: FC<{
    subscriptionState: State;
    subscribe: () => void;
    unsubscribe: () => void;
}> = ({ subscriptionState, subscribe, unsubscribe }) => {
    const { initialAccessCheck, userName } = useLoginKitState();

    if (!initialAccessCheck) {
        return <Spinner />;
    }

    return (
        <>
            <LoginKitPanel onLogout={() => unsubscribe()} />
            <FlexSection flexDirection="row" alignItems="baseline">
                <StatusLabel status={subscriptionState === State.Subscribed ? "success" : "warning"}>
                    Lens Studio: {subscriptionState}
                </StatusLabel>
                {userName &&
                    (subscriptionState === State.Unsubscribed ? (
                        <Button css={buttonStyle} onClick={subscribe}>
                            Subscribe
                        </Button>
                    ) : (
                        <Button css={buttonStyle} onClick={unsubscribe}>
                            Unsubscribe
                        </Button>
                    ))}
            </FlexSection>
        </>
    );
};
